import { extend, override } from "flarum/common/extend";
import Button from "flarum/common/components/Button";
import app from "flarum/forum/app";
import HeaderSecondary from "flarum/forum/components/HeaderSecondary";
import LogInButtons from "flarum/forum/components/LogInButtons";
import LogInModal from "flarum/forum/components/LogInModal";
import SignUpModal from "flarum/forum/components/SignUpModal";

const registrationUrl =
  "https://account.monstersandmemories.com/accounts/register";

app.initializers.add("mnm-sso-groups-oauth-only", () => {
  override(LogInModal.prototype, "body", function (_original) {
    return (
      <div className="MnmOAuthOnly">
        <p className="MnmOAuthOnly-description">
          {app.translator.trans("mnm-sso-groups.forum.oauth_only.description")}
        </p>
        <LogInButtons />
      </div>
    );
  });

  override(LogInModal.prototype, "footer", function (_original) {
    return (
      <p className="MnmOAuthOnly-signUp">
        {app.translator.trans("mnm-sso-groups.forum.oauth_only.sign_up_prompt")}{" "}
        <a href={registrationUrl}>
          {app.translator.trans("mnm-sso-groups.forum.oauth_only.sign_up_link")}
        </a>
      </p>
    );
  });

  override(LogInModal.prototype, "onready", function (_original) {});

  override(LogInModal.prototype, "onsubmit", function (_original, event) {
    event.preventDefault();
  });

  extend(SignUpModal.prototype, "oninit", function () {
    if (!this.attrs.token) {
      window.location.assign(registrationUrl);
    }
  });

  extend(HeaderSecondary.prototype, "items", function (items) {
    if (items.has("signUp")) {
      items.setContent(
        "signUp",
        <Button
          className="Button Button--link"
          onclick={() => window.location.assign(registrationUrl)}
        >
          {app.translator.trans("core.forum.header.sign_up_link")}
        </Button>,
      );
    }
  });
});
